module.exports = __webpack_public_path__ + "img/settings.dedc107e.svg";